import styled from 'styled-components'

export const Page = styled.div`
  height: 100%;
  background-color: white;
  
  .headContainer {
    display: flex;
    flex-direction: row;
    
    .title {
      padding-left: 1rem;
    }
  }
  
  .navbar {
    position: relative !important;
  }
  
  .modal-center {
    display: flex;
    justify-content: center;
  }
  
  .hidden {
    display: none;
  }
`

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: val(--primary-contrast);
  align-items: center;
  height: 100%;

  .loginForm {
    font-size: var(--typography-body-1-bold-size);
    color: var(--text-primary);
    font-family: var(--button-large);
    max-width: 30rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--boundvariablesdata);
    margin: 0 1rem;
  }

  .forgotten-password-parent {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 3rem 0.5rem 0;
  }

  .dont-have-an-container {
    position: relative;
    letter-spacing: 0.15px;
    line-height: 150%;
    white-space: pre;
    display: flex;
  }
  .dont-have-an-account-sign-up-wrapper {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    padding: var(--boundvariablesdata) var(--boundvariablesdata2) var(--boundvariablesdata2);
    align-items: center;
    justify-content: center;
  }

  .terms-of-service-container {
    position: relative;
  }
  .terms-of-service-privacy-pol-wrapper {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    padding: var(--boundvariablesdata) var(--boundvariablesdata2) var(--boundvariablesdata2);
    align-items: center;
    justify-content: center;
    color: var(--secondary-main);
  }
`

